import $ from "jquery";

$(function() {
    const $auflistung = $(".auflistungschulungen");
    initSlideDown($auflistung);
    initFilter($auflistung);
});

function initSlideDown($auflistung) {
    $auflistung.on("click", ".btnshowform", function() {
        const $btn = $(this);
        const $form = $btn.closest(".accordion-item").find(".schulunganmeldung");
        $form.slideDown(200);
    });
}

function initFilter($auflistung) {
    const $ctrfilter = $auflistung.find(".ctrfilter");
    $ctrfilter.on("click", "input[type=radio]", function() {
        const $radio = $(this);
        const filterVolunteer = $radio.val();

        function testItemVisible($item) {
            if(filterVolunteer === "*") {
                return true;
            } else {
                return filterVolunteer == $item.data("volunteer");
            }
        }

        $auflistung.find(".accordion-item").each(function() {
            const $item = $(this);
            $item.toggle(testItemVisible($item));
        });

        //animation
        const $accordion = $auflistung.find(".accordion");
        $accordion.hide();
        $accordion.fadeIn(400);
    });
}
